import { AlignmentType, Table, TableRow, WidthType } from 'docx'
import { normalizeCommissionQuestions } from '@/components/expCommissionQuestions/const'
import {
  createBoldParagraph,
  createContentParagraph,
  createParagraph,
  createSeparateParagraphs,
  createTableCell,
  DEFAULT_TABLE_MARGINS,
} from '../docxFunctions'

const NUM_COL_WIDTH = 8
const QUESTION_COL_WIDTH = 92
const CELL_SIZE = 22

function createTableHeaderRow() {
  return new TableRow({
    children: [
      createTableCell({
        width: { size: NUM_COL_WIDTH, type: WidthType.PERCENTAGE },
        verticalAlign: 'center',
        children: [
          createBoldParagraph(
            '№',
            { alignment: AlignmentType.CENTER },
            CELL_SIZE
          ),
        ],
      }),
      createTableCell({
        width: { size: QUESTION_COL_WIDTH, type: WidthType.PERCENTAGE },
        verticalAlign: 'center',
        children: [
          createBoldParagraph(
            'Вопрос',
            { alignment: AlignmentType.LEFT },
            CELL_SIZE
          ),
        ],
      }),
    ],
  })
}

function createParticipantHeaderRow(title) {
  const label = String(title || '').trim() || 'Участник'
  return new TableRow({
    children: [
      createTableCell({
        columnSpan: 2,
        children: [
          createContentParagraph(
            label,
            { alignment: AlignmentType.CENTER },
            { bold: true, italics: true, size: CELL_SIZE },
            false
          ),
        ],
      }),
    ],
  })
}

function createQuestionRow(num, text) {
  return new TableRow({
    children: [
      createTableCell({
        width: { size: NUM_COL_WIDTH, type: WidthType.PERCENTAGE },
        verticalAlign: 'center',
        children: [
          createParagraph(
            String(num),
            { alignment: AlignmentType.CENTER },
            {},
            CELL_SIZE
          ),
        ],
      }),
      createTableCell({
        width: { size: QUESTION_COL_WIDTH, type: WidthType.PERCENTAGE },
        children: createSeparateParagraphs(
          text,
          { alignment: AlignmentType.JUSTIFIED },
          {},
          CELL_SIZE
        ),
      }),
    ],
  })
}

function buildTableRows(data) {
  const rows = [createTableHeaderRow()]

  data.participants.forEach((participant, pIndex) => {
    const questions = (participant.questions || []).filter(q =>
      String(q?.text || '').trim()
    )
    if (!questions.length) return

    const title =
      String(participant.title || '').trim() || `Участник ${pIndex + 1}`

    rows.push(createParticipantHeaderRow(title))
    questions.forEach((q, qIndex) => {
      rows.push(createQuestionRow(qIndex + 1, q.text))
    })
  })

  return rows.length > 1 ? rows : null
}

export function createCommissionQuestionsTable(raw) {
  const data = normalizeCommissionQuestions(raw)
  if (!data?.hasQuestions) return null

  const rows = buildTableRows(data)
  if (!rows) return null

  return new Table({
    margins: DEFAULT_TABLE_MARGINS,
    width: {
      size: 100,
      type: WidthType.PERCENTAGE,
    },
    rows,
  })
}
